
export interface product {
  _id?: string | null;
  name: string;
  description: string;
  price: number | string;
  deposit: number | string;
  status: string;
  sku: string;
  datatype: string;
}

export const productdef: product = {
  _id: null,
  name: '',
  description: '',
  price: '',
  deposit: '',
  status: 'active',
  sku: '',
  datatype: 'product'
};

export interface locationitem {
  _id?: string | null;
  name: string;
  code: string;
  address: string;
  pins: string;
  capacitylimit: number | string;
  status: string;
  datatype: string;
}

export const locationitemdef: locationitem = {
  _id: null,
  name: '',
  code: '',
  address: '',
  pins: '',
  capacitylimit: '',
  status: 'open',
  datatype: 'location'
};

export interface deliverypartneritem {
  _id?: string | null;
  name: string;
  phone: string;
  status: string;
  datatype: string;
}

export const deliverypartneritemdef: deliverypartneritem = {
  _id: null,
  name: '',
  phone: '',
  status: 'active',
  datatype: 'deliverypartnerdata'
};

export interface deliveryitem {
  _id?: string | null;
  deliverydate: string;
  _subscriptionid: string;
  _userid: string;
  status: string;
  reason: string;
  notes: string;
  _deliverypartnerid: string;
  deliveryagent: { name: string; phone: string };
  datatype: string;
  // display only, enriched from subscription, never saved
  customername?: string;
  address?: string;
  items?: any[];
}

export const deliveryitemdef: deliveryitem = {
  _id: null,
  deliverydate: '',
  _subscriptionid: '',
  _userid: '',
  status: 'scheduled',
  reason: '',
  notes: '',
  _deliverypartnerid: '',
  deliveryagent: { name: '', phone: '' },
  datatype: 'deliverydata'
};

export interface opsteamuser {
  _id?: string | null;
  email: string;
  password?: string;
  datatype: string;
  usertype: string;
  appname?: string;
  status:string
}

export const opsteamuserdef: opsteamuser = {
  _id: null,
  email: '',
  password: '',
  datatype: 'appuser',
  usertype: 'admin',
  status:"active"
};

// a customer is an appuser (datatype "appuser") with usertype "customer",
// the same record shape Master uses for admins, so customers can log in.
// code is the display id (CUST-xxxxx), generated on first save when left empty.
export interface customer {
  _id?: string | null;
  code: string;
  name: string;
  email: string;
  password?: string;
  phone: string;
  pin: string;
  address: string;
  depositbalance: number | string;
  assetcount: string;
  status: string;
  usertype: string;
  datatype: string;
  timestamp?: string;
}

// blank customer used to reset the form when adding a new record
export const customerdef: customer = {
  _id: null,
  code: '',
  name: '',
  email: '',
  password: '',
  phone: '',
  pin: '',
  address: '',
  depositbalance: 0,
  assetcount: '',
  status: 'active',
  usertype: 'customer',
  datatype: 'appuser'
};

export interface subscriptionitem {
  productid: string;
  name: string;
  price: number | string;
  quantity: number;
}

// one record per checkout, a user can have many; the record carries its own
// delivery contact and address, separate from the customer profile.
export interface subscription {
  _id?: string | null;
  code: string;
  label: string;
  name: string;
  phone: string;
  address: string;
  pin: string;
  items: subscriptionitem[];
  frequency: string;
  preferredday: string;
  duration: string;
  startdate: string;
  enddate: string;
  cancelledat: string;
  itemstotal: number | string;
  deposittotal: number | string;
  discount: number | string;
  status: string;
  gatewaycustomerid: string;
  gatewaytokenid: string;
  gatewayorderid: string;
  mandatestatus: string;
  lastpaymentid: string;
  lastpaymentat: string;
  datatype: string;
}

// one record per checkout, _userid is stamped by the api
export const subscriptiondef: subscription = {
  _id: null,
  code: '',
  label: 'Home',
  name: '',
  phone: '',
  address: '',
  pin: '',
  items: [],
  frequency: 'weekly',
  preferredday: 'Mon',
  duration: '1month',
  startdate: '',
  enddate: '',
  cancelledat: '',
  itemstotal: 0,
  deposittotal: 0,
  discount: 0,
  status: 'pending',
  gatewaycustomerid: '',
  gatewaytokenid: '',
  gatewayorderid: '',
  mandatestatus: '',
  lastpaymentid: '',
  lastpaymentat: '',
  datatype: 'subscriptiondata'
};